import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { CircularProgress } from '@material-ui/core';
import { SubmitHandler, FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import Checkbox from '../../components/Form/Checkbox';
import Input from '../../components/Form/Input';
import { useAuth } from '../../hooks/auth';
import getValidationErrors from '../utils/getValidationErrors';
import { Container, OptionsContainer } from './styles';

interface FormData {
  username: string;
  password: string;
}

const SignIn: React.FC = (): JSX.Element => {
  const formRef = useRef<FormHandles>(null);

  const { signIn, loading } = useAuth();
  const [warning, setWarning] = useState(false);
  const [remember, setRemember] = useState(true);

  const handleSubmit: SubmitHandler<FormData> = async (data) => {
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        username: Yup.string()
          .email('Insira um email válido')
          .required('Obrigatório. Preencha com seu e-mail de acesso.'),
        password: Yup.string().required('Obrigatório. Preencha com sua senha'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });
      const { username, password } = data;

      await signIn({
        username,
        password,
      });
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
      }
    }
  };

  const checkCapsLock = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.getModifierState('CapsLock')) {
      if (!warning) {
        setWarning(true);
      } else if (e.getModifierState('CapsLock') && e.key === 'CapsLock') {
        setWarning(false);
      }
    } else {
      setWarning(false);
    }
  };

  useEffect(() => {
    const username = localStorage.getItem('@Afferolab:username');

    if (username) {
      setRemember(false);
      formRef.current?.setFieldValue('remember', 'remember');
      formRef.current?.setFieldValue('username', username);
    }
  }, []);

  const handleUsername = () => {
    if (formRef.current?.getFieldValue('username')) {
      setRemember(false);
    } else {
      formRef.current?.clearField('remember');
      setRemember(true);
    }
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      localStorage.setItem(
        '@Afferolab:username',
        formRef.current?.getFieldValue('username'),
      );
    } else {
      localStorage.removeItem('@Afferolab:username');
    }
  };

  return (
    <Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <h1>Login</h1>
        <Input
          name="username"
          type="email"
          placeholder="E-mail de login"
          label="E-mail de login"
          autoFocus
          onChange={() => handleUsername()}
        />
        <Input
          name="password"
          type="password"
          placeholder="Senha"
          label="Senha"
          onKeyUp={(e) => checkCapsLock(e)}
        />
        {warning && <span>Caps Lock ativado</span>}

        <OptionsContainer>
          <Checkbox
            name="remember"
            options={[
              {
                id: 'remember',
                value: 'remember',
                label: 'Lembrar-me',
              },
            ]}
            onChange={(e) => handleCheckboxChange(e)}
            disabled={remember}
          />
          <Link to="/forgot-password">Esqueci minha senha</Link>
        </OptionsContainer>

        <button type="submit">
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
        </button>
      </Form>
    </Container>
  );
};
export default SignIn;
